import { createAction } from "@reduxjs/toolkit";

// export const addBook = createAction('books/addBook');
// export const deleteBook = createAction('books/deleteBook');

export const setFromPage = createAction("from/setFromPage");
export const setFromItem = createAction("from/setFromItem");
